import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { getTempError } from "../redux/thunks/PublicResult";
import Button from "../components/sub-component/Button";
import Input from "../components/sub-component/Input";

export default function TempErrorPage() {
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [statusCode, setStatusCode] = useState(params?.error_code);

  const handleSubmit = async (e) => {
    dispatch(
      getTempError({
        data: {
          code: statusCode,
        },
      })
    );
  };

  useEffect(() => {
    dispatch(
      getTempError({
        data: {
          code: statusCode,
        },
      })
    );
  }, []);

  useEffect(() => {
    history.push(`/test-page/${statusCode}`);
  }, [statusCode]);

  return (
    <div>
      <h1>{statusCode} Error</h1>
      <div className="w-100 d-flex flex-column align-items-center justfy-content-center mb-4">
        <div
          className="d-flex flex-row align-items-center mt-4"
          style={{ width: "400px" }}
        >
          <label className="body-2 dark-50" style={{ width: "150px" }}>
            Status Code:
          </label>
          <Input
            onBoardingInput
            name="status_code"
            varrient={"primary"}
            onChange={(e) => {
              setStatusCode(e.target.value);
            }}
            type="text"
            value={statusCode}
          />
        </div>
        <div className="submit-button mt-4" style={{ width: "400px" }}>
          <Button
            style={{ width: "100%", padding: "0px 14px", height: "34px" }}
            varrient="primary"
            btn="ragular-btn"
            type={"submit"}
            title={"Submit"}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
}
